import ReactRB from "./api"
import emailConfirmationHandler from "./response-handlers/email-confirmation"

export const getCSRFToken = () =>
  document.querySelector("meta[name=csrf-token]")?.content

class RequestError extends Error {
  constructor(response) {
    super(
      response.body?.error ||
        response.body?.errors?.join(". ") ||
        "Something went wrong, try again."
    )
    this.response = response
  }
}

const request = async (
  action,
  {
    method = "get",
    headers = {},
    data,
    throwOnError = false,
    autoRedirect = true
  } = {}
) => {
  method = method.toLowerCase()
  let result = {}

  const response = await fetch(action, {
    method: method,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "X-CSRF-Token": getCSRFToken(),
      "X-React-RB": true,
      ...headers
    },
    body: method !== "get" ? JSON.stringify(data) : undefined
  })

  if (response.redirected && autoRedirect) {
    // TODO: Replace with ReactRB navigation
    window.location = response.url
    return result
  }

  if (response.headers.get("X-React-RB-Flash")) {
    const messages = JSON.parse(response.headers.get("X-React-RB-Flash"))

    for (let type in messages) {
      ReactRB.flash({ type, text: messages[type] })
    }
  }

  // handle non-json responses
  try {
    result = await response.json()
  } catch (e) {
    // do nothing
  }

  emailConfirmationHandler(response, result)

  // TODO: Deprecate. Once `redirect_to` is fully supported, we'll remove this.
  if (result.redirect && autoRedirect) {
    window.location = result.redirect
  }

  if (throwOnError && !response.ok)
    throw new RequestError({
      body: result,
      status: response.status,
      ...response
    })

  return {
    data: result,
    status: response.status,
    response: response,
    ok: response.ok
  }
}

export default request
